import React, { useState } from "react";
import Modal from "react-modal";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import "./index.css";
import { TfiLayoutGrid2Alt } from "react-icons/tfi";
import { RiCloseCircleFill } from "react-icons/ri";
import { useTranslation } from "../../../../../hooks/useTranslation";
Modal.setAppElement("#root");

const ImagesSlider = ({ images }) => {
  const { t } = useTranslation();
  const translations = t("adminHotelScreen");
  const [modalOpen, setModalOpen] = useState(false);
  const [sliderRef] = useKeenSlider({ loop: true });
  const fullImageUrls = images?.filter(Boolean)?.map((img) =>
    img.startsWith("http") ? img : `${img}`
  ) || [];
  const hasImages = fullImageUrls.length > 0;

  const [imageError, setImageError] = useState(false);

  return (
    <div className="relative">
      <div className="preview-image">
        {hasImages && !imageError ? (
          <img
            src={fullImageUrls[0]}
            alt="Preview"
            className="w-full h-[441px] object-cover"
            onError={() => setImageError(true)}
          />
        ) : (
          <div className="w-full h-[441px] bg-[#F5F5F5] flex items-center justify-center">
            <div className="text-center">
              <div className="text-[#9E9E9E] text-6xl mb-4">📷</div>
              <p className="text-[#9E9E9E] text-lg font-medium">No Image Available</p>
            </div>
          </div>
        )}
      </div>

      {hasImages && (
        <button
          onClick={() => setModalOpen(true)}
          className="px-[13px] py-[8px] rounded-[5px] bg-white text-[#4CAF50] text-base font-medium flex gap-[10px] items-center justify-center absolute bottom-[15px] right-[15px] z-10"
        >
          <TfiLayoutGrid2Alt size={18} /> {translations?.ShowAllPhotos}
        </button>
      )}

      {hasImages && (
        <Modal
          isOpen={modalOpen}
          onRequestClose={() => setModalOpen(false)}
          className="image-modal"
          overlayClassName="overlay"
        >
          <button
            onClick={() => setModalOpen(false)}
            className="absolute top-[20px] right-[20px] z-[1000] cursor-pointer hover:opacity-80 transition-opacity bg-black bg-opacity-50 rounded-full p-1"
          >
            <RiCloseCircleFill size={30} className="text-white" />
          </button>
          <div ref={sliderRef} className="keen-slider">
            {fullImageUrls.map((img, i) => (
              <div key={i} className="keen-slider__slide">
                <img 
                  src={img} 
                  alt={`slide-${i}`}
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
            ))}
          </div>
        </Modal>
      )}
    </div>
  );
};

export default ImagesSlider;
